module.exports = "<sui-multi-select \n  class=\"selection\"\n  placeholder=\"Membre\"\n  [ngModel]=\"active\"\n  (ngModelChange)=\"onChange($event)\"\n  [optionsLookup]=\"optionsLookup\"\n  labelField=\"name\"\n  valueField=\"user\"\n  [isSearchable]=\"true\"\n  #searchSelect>\n    <sui-select-option \n      *ngFor=\"let o of searchSelect.filteredOptions\" \n      [value]=\"o\">\n    </sui-select-option>\n</sui-multi-select>\n";


//////////////////
// WEBPACK FOOTER
// ./app/components/select-user-multiple/select-user-multiple.component.html
// module id = 1024
// module chunks = 0